// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__k2kLe","validationTips":"StatementDescriptor_validationTips__1xgR-"};